var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel panel-default filter-panel" }, [
    _vm._m(0),
    _c("div", { staticClass: "panel-body" }, [_vm._t("default")], 2)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "filter-panel__left" }, [
      _c("i", { staticClass: "fas fa-filter" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }